module.exports = __webpack_public_path__ + "static/image2-0b9188a3f755ba2eb41503eb9dce9006.jpg";